<div id="homeBase" class="routBase">
    <div class="container px-0 px-md-3">

        <div class="homeSlider">
            <ngx-slick-carousel *ngIf="sliderGames" class="homeCarousel" #slickModal="slick-carousel" [config]="homeSlideConfig" (beforeChange)="sliding = true" (afterChange)="sliding = false" >
                <img ngxSlickItem class="slideItem" *ngFor="let gameSlide of sliderGames; let i = index" src="{{ global.propConfs$?.proxyCachefly ? '/neo-cachefly' : 'https://lxneo.cachefly.net/m3/cache' }}/{{ gameSlide.id }}_156.jpg"
                    (click)="navToGame(gameSlide.catId, gameSlide.id)" [class.noClick]="sliding" [alt]="gameSlide.name">
                    <!-- ./../../../assets/images/slideImg{{ i }}.png -->
            </ngx-slick-carousel>

            <div *ngIf="!sliderGames" class="contentLoader my-5">
                <span></span>
            </div>
        </div>

        <div *ngFor="let category of categories$ | slice :0:3; let idx = index" class="gameGrid">

            <header class="px-3 py-1">
                <h6>{{ category.catName }}</h6>
                <a (click)="true" routerLink="/category/{{category.catId}}" queryParamsHandling="merge" title="{{ 'global.viewAll' | translate }}">{{ 'global.viewAll' | translate }} <i class="fas fa-chevron-right"></i></a>
            </header>

            <main *ngIf="categoryConten$" class="px-3 px-md-0" [ngClass]="{'topCat': (idx == 0 || idx == 2), 'slickSim': idx == 1}">

                <div *ngFor="let game of categoryConten$[category.catId]" routerLink="/game/{{game.catId}}/{{game.id}}" queryParamsHandling="merge" class="gameThumb p-2 px-xl-3">
                    <img src="{{ global.propConfs$?.proxyCachefly ? '/neo-cachefly' : 'https://lxneo.cachefly.net/m3/cache' }}/{{ game.id }}_55.jpg" [alt]="game.name">
                    <p>{{ game.name }}</p>
                    <div class="rankStars">
                        <span *ngFor="let star of [].constructor(game.rank)"><i class="fas fa-star"></i></span>
                    </div>
                </div>

            </main>

            <div *ngIf="!categoryConten$[category.catId]" class="contentLoader my-5">
                <span></span>
            </div>

        </div>
    </div>
</div>